<!-- 老师管理 -->
<template>
  <div class="fuzzy-matching-box">
      <!-- 老师管理 -->
    <div class="fuzzy-matching-top">

      <el-row class="top-first-line the-second-line">
        <el-col :span="5">
          <el-form-item label="用户名:">
            <el-input v-model="Dform.userName" placeholder=''></el-input>
          </el-form-item>
        </el-col >
        <el-col :span="5">
          <el-form-item label="姓名:">
            <el-input v-model="Dform.name" placeholder=''></el-input>
          </el-form-item>
        </el-col >
        <el-col :span="5">
          <el-form-item label="一级管理员:">
            <el-input v-model="Dform.schoolName" placeholder=''></el-input>
          </el-form-item>
        </el-col >
          <el-col :span="5">
          </el-col >
        <el-button type="primary" class="query-button" @click="entrylogClick">查询</el-button>
      </el-row>
    </div>
    <div class="fuzzy-matching-content">
      <el-button type="text"  class="query-button" @click="AddClick" v-if=" teacherObj.schoolId ==null">一级管理员</el-button>
      <el-button type="text" class="query-button" @click="daoRuClick" v-if=" teacherObj.gradeId == null">二级管理员</el-button>
      <el-button type="text" class="query-button" @click="deriveFamily"   v-if="teacherObj.classId ==null">三级管理员</el-button>
    </div>
    <div class="fuzzy-matching-bottom">
      <el-row class="list">
        <el-table
          stripe
          :border="true"
          v-loading="loading"
          :header-cell-style="{background:'#EDF6FF',color:'#000',}"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column
            label="类型"
            show-overflow-tooltip>
              <template #default="scope">
                  <span v-if="scope.row.type == 0">{{'系统管理员'}}</span>
                  <span v-if="scope.row.type == 1">{{'一级管理员'}}</span>
                  <span v-if="scope.row.type == 2">{{'二级管理员'}}</span>
                  <span v-if="scope.row.type == 3">{{'三级管理员'}}</span>
                </template>
              </el-table-column>
          <el-table-column
            prop="username"
            label="用户名"
            >
          </el-table-column>
            <el-table-column
            prop="name"
            label='姓名'
            >
          </el-table-column>
          <el-table-column
            prop="mobile"
            label="手机"
            >
          </el-table-column>
          <el-table-column
            prop="schoolName"
            label="一级管理员"
            >
          </el-table-column>
          <el-table-column
            prop="gradeName"
            label="二级管理员"
            >
          </el-table-column>
          <el-table-column
            prop="className"
            label="三级管理员"
            >
          </el-table-column>
          <!-- <el-table-column
            prop="maxMsg"
            label="短信额度"
            >
          </el-table-column>
          <el-table-column
            prop="usedMsg"
            label="已使用"
            >
          </el-table-column> -->

          <el-table-column
            label="操作"
            >
            <template #default="scope">
            <el-button type="text" size="small" class='textButton' @click="reviseClick(scope.row)">修改</el-button>
            <el-button type="text" size="small" class="shanchuBtn"   @click="deleteClick(scope.row)">删除</el-button>
          </template>
          </el-table-column>
          
        </el-table>

        <div class="block-fenye" >
          <el-pagination
              :small="small"
              :disabled="disabled"
              :background="background"
              layout="prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
          />
        </div>
      </el-row>

    </div>
    <AddSchoolAdministrator v-if="AddShow" :titleValue="titleValue" :detailsObj="detailsObj" @addClick="addClick"></AddSchoolAdministrator>
  </div>
</template>

<script>
import { schoolOrUserManagementTeacherList, deleteTeacherInfo} from '@/assets/api/schoollog';
import { findSchoolInfo,findTeacherInfo,findClassInfo } from '@/assets/api/renyuan';
import AddSchoolAdministrator from './group/add-school-administrator.vue'

import { ElMessage } from 'element-plus'
export default {
  components: {
    AddSchoolAdministrator
  },
  data() {
      return {
        teacherObj:{},
        loading:true,
        tableData:[],
        Dform:{
          userName:"",
          name:"",
          schoolName:"",
        },
        pageInfo:{
          pageSize:"10",
          page:"1",
        },
        titleValue: '',
        AddShow: false,
        total: '',
        detailsObj: {},
      };
  },
  created() {
    this.Lookteacher()
    this.schoolOrUserManagementTeacherListSearch()
  },
  mounted() {

  },
  methods: {
    // 删除
    deleteClick(item){
      console.log(item);
      const params ={
        userId:JSON.parse(localStorage.getItem('user')).id,
        id:item.id
      }
      deleteTeacherInfo(params).then((res) => {
        console.log(res,222);
        ElMessage.success('删除成功')
        this.schoolOrUserManagementTeacherListSearch()
      }).catch((err) => {
        console.log(err,111);
        ElMessage.error('删除失败')
      })
    },
    reviseClick (item) {
      console.log(item,666666);
      // this.detailsObj = item
      this.titleValue = item.type==0? '系统管理员修改':'' || item.type==1? '一级管理员修改':'' ||item.type==2? '二级管理员修改':''|| item.type==3? '三级管理员修改':''
      if ( item.type == 1 || item.type == 2 || item.type == 3 ) {
        this.findTeacherInfoGet(item)
      } 
    },
    // findClassInfoGet (item) {
    //   let params = {
    //     classId : item.classId,
    //     userId:JSON.parse(localStorage.getItem('user')).id,
    //   }
    //   findClassInfo(params).then((res)=> {
    //     this.AddShow = true
    //     this.detailsObj = res.data.data
    //     console.log(res,'班级详细信息');
    //   }).catch((err)=> {
    //     console.log(err);
    //   })
    // },
    Lookteacher () {
      let params = {
        userId :JSON.parse(localStorage.getItem('user')).id,
      }
      findTeacherInfo(params).then((res)=> {
        console.log(res,'查看权限');
        this.teacherObj = res.data.data
      }).catch((err)=> {
        console.log(err);
      })
    },

    findTeacherInfoGet (item) {
      let params = {
        userId : item.id,
      }
      findTeacherInfo(params).then((res)=> {
        this.AddShow = true
        this.detailsObj = res.data.data
        console.log(res,'学校管理员详情');
      }).catch((err)=> {
        console.log(err);
      })
    },
    AddClick () {
      this.titleValue = '新增一级管理员'
      this.AddShow = true
    },
    daoRuClick () {
      this.titleValue = '新增二级管理员'
      this.AddShow = true
    },
    deriveFamily () {
      this.titleValue = '新增三级管理员'
      this.AddShow = true
    },
    addClick () {
      this.AddShow = false
      this.schoolOrUserManagementTeacherListSearch()
    },
    schoolOrUserManagementTeacherListSearch(){
      const params = {
        schoolName:this.Dform.schoolName,
        userName:this.Dform.userName,
        name:this.Dform.name,
        page:this.pageInfo.page,
        pageSize:this.pageInfo.pageSize,
        userId:JSON.parse(localStorage.getItem('user')).id,
      }
      schoolOrUserManagementTeacherList(params).then((res)=> {
          console.log(res,'教师管理成功');
          this.tableData = res.data.data.list
          this.total = res.data.data.total
          this.loading = false
      }).catch((err)=> {
        console.log(err,'教师管理失败');

      })
    },
    entrylogClick(){
    this.schoolOrUserManagementTeacherListSearch()

    },
    handleSizeChange(val) {
    console.log(`每页 ${val} 条`);
  },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageInfo.page = val
      this.schoolOrUserManagementTeacherListSearch()
    },
  },
};
</script>

<style scoped lang="scss">
.fuzzy-matching-box {
  padding-top: 20px;
  // overflow: hidden;
  // overflow: auto;
  width: 100%;
  height:  96%;
  background-color: #fff;
  border-radius: 8px;
  .query-button{
      margin: 2px;
      padding: 0px;
      font-size: 15px;
      font-weight: 700;
  }
  .title-top {
      padding: 20px 20px;
  }
  .fuzzy-matching-top {
  height: 70px ;
  background-color: #fff;
  border-radius: 8px;
  .top-first-line {
    /deep/ {
      .el-form-item--small .el-form-item__label {
        // background-color: red;
        font-size: 16px;
      }
      .el-select--small {
          width: 100%
      }
      .el-form-item--small .el-form-item__label {
        width: 110px;
        text-align: right;
        height: 35px;
        line-height: 35px;          
        font-weight: 700;
      }
      .el-input {
        width: 100%;
        height: 35px;
      }
    }
  }
  .the-second-line {
    margin-top: 15px;
    position: relative;
    .query-button {
      position: absolute;
      right: 300px;
      padding: 16px 24px;
      // top: 50%;
      // transform: translate(0,-50%);
      // background-color: #1677FF;
    }
   
  }
  /deep/ {
    .el-range-editor--small.el-input__wrapper {
        height: 35px;
        line-height: 35px;  
    }
  }

}
.fuzzy-matching-content{
  height: 20px;
  line-height: 20px;
  margin-bottom: 10px;
  /deep/{
      .el-button{
          margin-left:50px;
          font-size: 16px;
          
      }
  }
}
.fuzzy-matching-bottom {
      // position: absolute;
      padding: 20px;
    .textButton {
      // background-color: pink;
      margin: 2px;
      padding: 0px;
      font-size: 15px;
      font-weight: 700;
    }
    .shanchuBtn {
      // background-color: pink;
      margin: 2px;
      padding: 0px;
      font-size: 15px;
      font-weight: 700;
      color: red;
    }
      /deep/{
        .el-table th.el-table__cell>.cell {
          height: 30px;
          line-height: 30px;
          text-align: center;
          font-size: 16px;
      }
      .el-table td.el-table__cell div{
        text-align: center;
        height: 40px;
        line-height: 40px;
        border: 0;
        font-size: 16px;
        color: black;
      }
      .el-table:not(.el-table--border) .el-table__cell{
        border: 0;
      }
      .el-button--small {
          padding-left: 19px;
      }
} 
    .block-fenye{
      margin-left: 1000px;
      margin-top: 15px;
}
}
      
}
</style>
